<div
  class="chatbot-history-item d-flex align-items-center gap-2 rounded-3"
  :class="{ active: is_active }"
  @click="$emit('select', conversation.id)"
>
  <div class="chatbot-history-item-body min-w-0 flex-grow-1">
    <p class="text-white text-xs fw-semibold mb-1 text-truncate">
      {{ conversation_title }}
    </p>
    <p class="text-white-50 text-xs mb-0 text-truncate">
      {{ conversation_preview }}
    </p>
    <time
      v-if="conversation_timestamp"
      class="chatbot-history-timestamp d-flex align-items-center flex-wrap"
      :datetime="conversation_timestamp_value"
      :title="conversation_timestamp"
    >
      <span class="chatbot-history-date">{{ conversation_date_label }}</span>
    </time>
  </div>

  <button
    v-if="can_delete"
    class="btn btn-sm btn-outline-light border-0 d-inline-flex align-items-center justify-content-center p-0 chatbot-delete-btn"
    @click.stop="$emit('delete', conversation.id)"
    aria-label="Delete conversation"
    title="Delete conversation"
  >
    <i class="bi bi-trash3"></i>
  </button>
</div>
